import React from 'react';
import styles from './WebBanner.module.css';
import logo from '../../../images/ttg.png'
import supportCombined from '../../../images/2-in-1.png'
import ContactButton from '../../ContactButton/ContactButton';

const WebBanner = () => {
  return (
    <div className={styles.banner}>
      <a href="/">
        <div className={styles.logo}>
          <img src={logo} />
          <div className={styles.logoText}>
            Invoicing
            <br />
            Portal
          </div>
        </div>
      </a>
      <div className={styles.rightContent}>
        <div className={styles.supportBlock}>
          <img src={supportCombined} alt="Proudly Supports Energy Foundation Collective" className={styles.supportCombined} />
        </div>
        <div className={styles.actionRow}>
          {/* <DemoSwitch onChangeDemoMode={onChangeDemoMode} /> */}
          <ContactButton />
        </div>
      </div>
    </div>
  );
};

export default WebBanner;
